import { useRef, useState } from "react"
import { useLocation } from "react-router-dom"
import { SectionHeading, TableCustom, WrapperAdvancedSearch, FooterButtonVolver } from "../../components/common"
import { useManagedContext } from "../../components/hooks"
import { usePermissions } from "../../components/hooks/usePermissions"
import CategoriaTasaModal from "../../components/controls/CategoriaTasaModal"
import { ServerRequest } from "../../utils/apiweb"
import { OPERATION_MODE, REQUEST_METHOD } from '@laramie/ui';
import { APIS } from "../../config/apis"
import { onRequestError, onRequestNoSuccess } from "../../utils/requests"
import { PERMISSIONS } from "../../consts/permissions"
import { useSearchParams } from "react-router-dom"
const CategoriasTasasView = () => {
    const { setIsLoading, showMessageModal } = useManagedContext()
    const location = useLocation()
    const previousFilters = location.state?.filters

    const [data, setData] = useState([])
    const [editMode, setEditMode] = useState()
    const [editItem, setEditItem] = useState()
    const [tableVisible, setTableVisible] = useState(false)

    const searchRef = useRef()

    const { hasPermission } = usePermissions();
    const [search] = useSearchParams();
    const canEdit = hasPermission(PERMISSIONS.LISTAS_INGRESOS_PUBLICOS_EDIT);
    const isViewOnly = search.get('mode') === OPERATION_MODE.VIEW;
    const allowEditActions = canEdit && !isViewOnly;

    const SearchCategorias = () => {
        const filterData = newData => {
            const { codigo, nombre } = searchRef.current.filters

            let filtered = [...newData]
    
            if (codigo !== '') filtered = filtered.filter(item => item.codigo.toLowerCase().includes(codigo.toLowerCase()))
            if (nombre !== '') filtered = filtered.filter(item => item.nombre.toLowerCase().includes(nombre.toLowerCase()))
    
            return filtered
        }

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.CATEGORIA_TASA,
            null,
            null,
            res => res.json().then(data => {
                setData(filterData(data))
                setIsLoading(false)
                setTableVisible(true)
                setEditMode(null)
                setEditItem(null)
            }),
            res => {
                onRequestNoSuccess(res)
                setIsLoading(false)
                setEditMode(null)
                setEditItem(null)
            },
            err => {
                onRequestError(err)
                setIsLoading(false)
                setEditMode(null)
                setEditItem(null)
            },
        )
    }

    const confirmRemoveId = (id) => {
        setIsLoading(true)
        ServerRequest(
            REQUEST_METHOD.DELETE,
            null,
            true,
            APIS.URLS.CATEGORIA_TASA,
            `/${id}`,
            null,
            () => {
                SearchCategorias()
                setIsLoading(false)
            },
            res => {
                onRequestNoSuccess(res)
                setIsLoading(false)
            },
            err => {
                onRequestError(err)
                setIsLoading(false)
            },
        )
    }

    const avmr = {
        onAdd: () => {
            setEditMode('add')
            setEditItem({
                id: -Date.now(),
                codigo: '',
                nombre: '',
                orden: '',
                esPlan: false,
                esDerechoEspontaneo: false,
            })
        },
        onView: (item) => {
            setEditMode('view')
            setEditItem(item)
        },
        onModify: (item) => {
            setEditMode('modify')
            setEditItem(item)
        },
        onRemove: ({ id }) => {
            showMessageModal({
                title: "Confirmación",
                message: "¿Está seguro de borrar el registro?",
                onConfirm: () => confirmRemoveId(id),
            })
        }
    }

    const onEditConfirm = () => {
        if (tableVisible) SearchCategorias()
        else {
            setEditMode(null)
            setEditItem(null)
        }
    }

    const onEditCancel = () => {
        setEditMode(null)
        setEditItem(null)
    }
    
    return <>
       <SectionHeading titles={[{ title: 'Entidades' }, { title: 'Administración de listas', url: '/entidades' }, { title: 'Categorías de tasas' }]}
                       onAddClick={allowEditActions ? avmr.onAdd : null} tableVisible={tableVisible} />

        <section className="section-accordion">
            <WrapperAdvancedSearch
                ref={searchRef}
                filters={[
                    { title: 'Código', field: 'codigo', type: 'string', size: 1 },
                    { title: 'Nombre', field: 'nombre', type: 'string', size: 3 },
                ]}
                onSearch={SearchCategorias}
            />

            {tableVisible && (
                <TableCustom
                    className={'TableCustomBase m-top-20'}
                    data={data}
                    avmr={avmr}
                    editCode={PERMISSIONS.LISTAS_INGRESOS_PUBLICOS_EDIT}
                    disabled={!allowEditActions}
                    messageEmpty="No se encontraron resultados"
                    columns={[
                        { Header: 'Código', accessor: 'codigo', },
                        { Header: 'Nombre', accessor: 'nombre', },
                    ]}
                />
            )}

            {editItem && (
                <CategoriaTasaModal
                    item={editItem}
                    editMode={editMode}
                    onConfirm={onEditConfirm}
                    onCancel={onEditCancel}
                />
            )}

        </section>
        <footer className='footer footer-action'>
            <div className='footer-action-container'>
                <FooterButtonVolver filters={previousFilters} to="/entidades" />
            </div>
        </footer>
    </>
}

export default CategoriasTasasView
